import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useFile } from './useFile';

export const useFilePreview = (files = []) => {
  const { fileUuid } = useParams();

  const currentFile = useMemo(
    () => files.find((file) => file.uuid === fileUuid),
    [files, fileUuid],
  );

  const { error, data, isLoading } = useFile({
    fileUuid,
    enabled: !currentFile && !!fileUuid,
  });

  return {
    filePreview: currentFile || data?.file,
    fileNotFound: !!error,
    isLoading,
  };
};
